module.exports = __webpack_public_path__ + "static/media/photo_displays.1216a42a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SideImage/photo_displays.jpg
// module id = 390
// module chunks = 0